export default __webpack_public_path__ + "static/media/Suncrown - Legend of the Forgotten Centuries.7fc833c5.mp3";